import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  prismProgram: 'HealthPrism'
}

export const customDashboardViewSlice = createSlice({
  name: 'customDashboardView',
  initialState,
  reducers: {
    setPrismProgram: (state, action) => {
      state.prismProgram = action.payload
    },
    resetCustomDashboardView: () => initialState
  }
})

export const {setPrismProgram, resetCustomDashboardView} = customDashboardViewSlice.actions

// Selectors
export const selectPrismProgram = (state) => state.customDashboardView.prismProgram

export default customDashboardViewSlice.reducer
